<header class="app-header navbar">
  <button class="navbar-toggler d-lg-none" type="button" appMobileSidebarToggler>&#9776;</button>
  <a class="navbar-brand" routerLink="/user">
      <img src="assets/img/logo.png">
  </a>
  <button class="navbar-toggler d-md-down-none" type="button" appSidebarToggler>&#9776;</button>
  <ul class="nav navbar-nav ml-auto">
    <li class="nav-item dropdown" ngbDropdown>
      <a class="nav-link dropdown-toggle" ngbDropdownToggle>
        <img src="assets/img/avatars/user.png" *ngIf="userData.image ==''" class="img-avatar">
        <img *ngIf="userData.image !=''" [src]="'data:image/jpg;base64,'+userData.image" class="img-avatar">
        <span class="d-md-down-none">{{userData.profileName}}</span>
      </a>
      <div class="dropdown-menu dropdown-menu-left" ngbDropdownMenu aria-labelledby="dropdownBasic1">
        <a class="dropdown-item" routerLink="/profile-settings"><i class="fa fa-user"></i> Profile</a>
        <a class="dropdown-item" (click)="logout()"><i class="fa fa-lock"></i> Logout</a>
      </div>
    </li>
  </ul>
</header>
<div class="app-body">
  <div class="sidebar">
    <nav class="sidebar-nav">
      <ul class="nav">
        <!-- <li class="nav-item"><a class="nav-link active" routerlinkactive="active" href="/user"><i class="fa fa-users"></i>Manage User</a></li>        
        <li class="nav-item"><a class="nav-link active" routerlinkactive="active" href="/country"><i class="fa fa-users"></i>Manage Country</a></li>
        <li class="nav-item"><a class="nav-link active" routerlinkactive="active" href="/state"><i class="fa fa-users"></i>Manage State</a></li>
        <li class="nav-item"><a class="nav-link active" routerlinkactive="active" href="/city"><i class="fa fa-users"></i>Manage City</a></li>
        <li class="nav-item"><a class="nav-link active" routerlinkactive="active" href="/qualification"><i class="fa fa-users"></i>Manage Qualification</a></li>
        <li class="nav-item"><a class="nav-link active" routerlinkactive="active" href="/area-of-interest"><i class="fa fa-users"></i>Manage Area Of Interest</a></li>
        <li class="nav-item"><a class="nav-link active" routerlinkactive="active" href="/sector-of-enterprise"><i class="fa fa-users"></i>Manage Sector Of Enterprise</a></li>
        <li class="nav-item"><a class="nav-link active" routerlinkactive="active" href="/type-of-enterprise"><i class="fa fa-users"></i>Manage Type Of Enterprise</a></li>
        <li class="nav-item"><a class="nav-link active" routerlinkactive="active" href="/stage-of-business"><i class="fa fa-users"></i>Manage Stage Of Business</a></li>
        <li class="nav-item"><a class="nav-link active" routerlinkactive="active" href="/area-of-specialization"><i class="fa fa-users"></i>Manage Area Of Specialization</a></li>
        <li class="nav-item"><a class="nav-link active" routerlinkactive="active" href="/blog"><i class="fa fa-users"></i>Manage Blog</a></li>
        <li class="nav-item"><a class="nav-link active" routerlinkactive="active" href="/product"><i class="fa fa-users"></i>Manage Product</a></li> -->

        <ng-container *ngFor="let item of nav; let i=index">
          <li class="nav-item"  *ngIf="item.type==null">
              <a class="nav-link" routerLinkActive="active" routerLink="/{{item.route}}"><i class="{{item.icon}}"></i>{{item.name}}</a>
          </li>
          <li class="nav-item nav-dropdown" *ngIf="item.type==1" routerLinkActive="open" appNavDropdown>
              <a *ngIf="item.type==1" class="nav-link nav-dropdown-toggle" appNavDropdownToggle><i class="{{item.icon}}"></i>{{item.name}}</a>
              <ul *ngIf="item.type==1" class="nav-dropdown-items">
                  <li class="nav-item" *ngFor="let sub of nav[i]['children']">
                      <a routerLinkActive="active" routerLink="/{{sub.route}}" class="nav-link"> {{sub.subMenu}}</a>
                  </li>
              </ul>
          </li>
        </ng-container>
      </ul>
    </nav>
  </div>

  <!-- Main content -->
  <main class="main">
    <!-- Breadcrumb -->
    <!-- <ol class="breadcrumb">
      <app-breadcrumbs></app-breadcrumbs>
    
    </ol> -->
    <div class="container-fluid mt-3" style="">
      <!-- <alert></alert> -->
      <router-outlet></router-outlet>
    </div><!-- /.conainer-fluid -->
  </main>
</div>

<footer class="app-footer">
  Copyright &copy; WEP. All rights reserved 2022.
</footer>
